<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    高铁<br>
    <a href="http://www.fengliebiao.com/shenzhenbei.html">深圳北站地铁站</a>
<a href="http://www.12306.cn">12306官网</a>
温馨提示：<br>
1.带口罩<br>
2.微信出示粤省事小程序<br>
3.准备身份证或出示高铁车票二维码<br>
4.人和行礼安检<br>
5.按检票口等候，同样可用刷身份证检票或出示高铁车票二维码扫码检票<br></br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        // {
        //   name: "",
        //   title: "",
        //   // icon: "chat",
        //   exact: true,
        // },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>

